<ion-content>
  <div class="center-align-content">
    <div>
      <!-- this div is to wrap the contents of the page for alignment-->
      <div class="mable-section">
        <div class="sub-section">
          <ion-img
            class="padding-top width-40"
            [src]="'/assets/img/mable/eol.svg'"
          ></ion-img>
        </div>

        <div class="sub-section">
          <mable-heading
            heading="h1"
            class="ion-text heading"
            >{{ 'This app no longer works' }}
          </mable-heading>
          <p class="body-semi-bold ion-text text-no-margin">The new Mable app is ready for you.</p>
          <p class="body-semi ion-text text-no-margin">
            Delete this app, then open or download the new Mable app to continue.
          </p>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <mable-button
    expand="block"
    class="ion-margin"
    category="orange-500"
    (onClick)="openAppStoreClient()"
    >Download the new Mable app
  </mable-button>
</ion-footer>
